export type TriageQueueFilters = {
  category?: string;
  subcategory?: string;
  neighborhood?: string;
  startDate?: string;
  endDate?: string;
  hasAttachments?: boolean;
  search?: string;
  page?: number;
  limit?: number;
  sortBy?: "createdAt" | "updatedAt" | "status" | "protocol" | "waitingTime";
  sortOrder?: "asc" | "desc";
};

export type OccurrenceQueueItem = {
  id: string;
  protocol: string;
  createdAt: string;
  updatedAt: string;
  category: {
    id: string;
    name: string;
  };
  subcategory: {
    id: string;
    name: string;
  };
  neighborhood: string;
  address: string;
  latitude?: number;
  longitude?: number;
  citizen: {
    id: string;
    fullName: string;
    cpf?: string;
  };
  timeInQueue: number; // em minutos
  hasAttachments: boolean;
  attachmentCount: number;
  status: string;
  isBeingAnalyzed: boolean; // Se outro atendente está analisando
  analyzedBy?: string;
  analyzer?: {
    id: string;
    email: string;
    profile: {
      fullName: string;
    };
  };
  isReopened: boolean;
  description: string;
  userPerceivedUrgency?: "LOW" | "MEDIUM" | "HIGH" | "URGENT";
  priority?: "LOW" | "MEDIUM" | "HIGH" | "URGENT";
  isAnonymous?: boolean;
};

export type TriageQueueResponse = {
  data: OccurrenceQueueItem[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
};

export type TimeInQueueIndicator = "normal" | "attention" | "alert" | "critical";

export const getTimeIndicator = (timeInMinutes: number): TimeInQueueIndicator => {
  const hours = timeInMinutes / 60;
  
  if (hours > 24) return "critical";
  if (hours > 8) return "alert";
  if (hours > 4) return "attention";
  return "normal";
};

export const getTimeIndicatorColor = (indicator: TimeInQueueIndicator): string => {
  const colors = {
    normal: "text-green-600 bg-green-50 border-green-200",
    attention: "text-yellow-600 bg-yellow-50 border-yellow-200",
    alert: "text-orange-600 bg-orange-50 border-orange-200",
    critical: "text-red-600 bg-red-50 border-red-200",
  };
  return colors[indicator];
};

export const formatTimeInQueue = (minutes: number): string => {
  if (minutes < 60) {
    return `${minutes}min`;
  }
  
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  
  if (hours < 24) {
    return mins > 0 ? `${hours}h ${mins}min` : `${hours}h`;
  }
  
  const days = Math.floor(hours / 24);
  const remainingHours = hours % 24;
  
  if (remainingHours > 0) {
    return `${days}d ${remainingHours}h`;
  }
  
  return `${days} ${days === 1 ? 'dia' : 'dias'}`;
};
